module.exports = __webpack_public_path__ + "img/justice-midle-image.9410f3ef.png";